import { useState, useEffect, useContext } from 'react';
import {
    countTypes,
    searchProductType
} from '../services/TypeService'

export const useType = (filters = {}) => {
    const [productsSearchType, setProductsSearchType] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const searchProductTypePost = async (param) => {
        try {
            // setLoading(true);
            const response = await searchProductType(param);

            setProductsSearchType(response.data);
            setLoading(false);
        } catch (err) {
            setError('Failed to fetch products');
        } finally {
            setLoading(false);
        }
    };


    const countTypeProduct = async () => {
        try {
            setLoading(true);
            const response = await countTypes();

            setProductsSearchType(response.data);
            setLoading(false);
        } catch (err) {
            setError('Failed to fetch products');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        countTypeProduct();
      }, []);

    return {
        searchProductTypePost,
        countTypeProduct,
        loading,
        productsSearchType
    };
};
